import { createContext } from 'react';

// Optional local portal host for embedded surfaces. Undefined preserves body portals.
export const PortalContainerContext = createContext(undefined);
